<template>
  <div class="wrap">
    <div class="exam" ref="inboxRef">
      <div class="bg_w">
        <span class="span" style="font-size: 13px;min-width: 70px">{{
            group ? $t('select.user') : $t('common.emailbox.select')
          }}：</span>
        <el-select v-model="selectedTeamId" @change="handleSelectUser" size="small"
                   :placeholder="$t('common.email.chooseEmail')"
                   style="margin-right: 10px;width: 150px!important;">
          <el-option
              v-for="item in tableDataSelect"
              :label="item.userName"
              :value="item.userId"
              :key="item.userId"
          />
          <el-option :label="$t('common.all')" :value="$t('common.all')" :key="$t('common.all')"></el-option>
        </el-select>
        <el-select v-model="configId" size="small" style="width: 150px !important;">
          <el-option :label="$t('common.setting.allEmail')" value="all" id="all"/>
          <el-option
              v-for="item in emailList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
          />
        </el-select>
        <div style="flex-grow: 1;"></div>
      </div>
      <div class="screen">
        <div class="screen_btn">
          <ElButton v-if="isAdmin||isSuperAdmin" size="small" :loading="btnIsLoadingResolve" type="primary"
                    @click="() => handlePass(1)">
            {{ $t('email.list.examine') }}
          </ElButton>
          <ElButton v-if="isAdmin||isSuperAdmin" size="small" :loading="btnIsLoadingReject"
                    @click="() => handlePass(2)">
            {{ $t('email.list.examine.reject') }}
          </ElButton>
        </div>
        <el-pagination
            v-model:current-page="current"
            v-model:page-size="size"
            small="small"
            layout="total, prev, pager, next, jumper"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
        />
      </div>
      <!--      新的移动模块-->
      <div class="Drag2" ref="DragBox">
        <div class="box" ref="box">
          <!--      <div class="left">-->
          <!--        &lt;!&ndash;左侧div内容&ndash;&gt;-->
          <!--      </div>-->
          <!--      <div class="resize" title="左右侧边栏">⋮</div>-->
          <div class="mid">
            <!--右侧div内容-->
            <div class="topBox" :style="{height:fileInboxTop+'px'}">
              <!--右上div内容-->
              <ElTable v-loading="loading"
                       :height="'100%'"
                       :data="list"
                       @selection-change="handleSelectionChange"
                       size="small"
                       ref="tableRef"
                       highlight-current-row
                       @current-change="handleCurrentRowChange"
                       :cell-style="rowClassName"
                       :row-style="{height: '30px'}"
                       :header-cell-style="headerClassName"
                       :row-class-name="tableRowClassName"
                       @sort-change="sort_change"
                       @row-dblclick="handleViewDetail"
              >
                <el-table-column type="selection" width="20"/>
                <el-table-column width="20" prop="isStress" sortable="custom"
                                 class-name="sort_ps"
                >
                  <template #header>
                    <img style="position: absolute;left: 6px;top: 9px;" src="@/assets/email/hp.svg"/>
                  </template>
                  <template #default="scope">
                    <img v-if="scope.row.isStress === 1" style="position: absolute;left: 6px;top: 9px;"
                         @click.stop="() => handleSettingStress(scope, 3)"
                         class="pointer flags_f"
                         src="@/assets/email/hp.svg"/>
                    <img v-else class="pointer flags_f" style="position: absolute;left: 6px;top: 9px;"
                         @click.stop="() => handleSettingStress(scope, 2)"
                         src="@/assets/email/hp1.svg"/>
                  </template>
                </el-table-column>
                <el-table-column width="30" prop="isRead" sortable="custom" class-name="sort_ps">
                  <template #header>
                    <img style="position: absolute;left: 8px;top: 9px;" src="@/assets/email/weidu.svg"/>
                  </template>
                  <template #default="scope">
                    <img style="position: absolute;left: 8px;top: 6px" v-if="scope.row.isRead === 1"
                         @click.stop="() => handleSetRead(scope)" class="pointer"
                         src="@/assets/email/yidu.svg"/>
                    <img style="position: absolute;left: 8px;top:9px" v-else class="pointer"
                         @click.stop="() => handleSetRead(scope)"
                         src="@/assets/email/weidu.svg"/>
                  </template>
                </el-table-column>
                <el-table-column width="20" prop="fj" sortable="custom" class-name="sort_ps">
                  <template #header>
                    <img style="position: absolute;left: 6px;top:9px" src="@/assets/email/fj.svg"/>
                  </template>
                  <template #default="scope">
                    <img style="position: absolute;left: 6px;top:9px" v-if="scope.row.isExtend===1" class="pointer"
                         src="../../assets/email/fj.svg"
                         @click.stop="() => handleDownload(scope)"/>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="mailRecipientList"
                    :label="$t('common.email.to')"
                    width="200"
                >
                  <template #default="scope">
                    <!-- 有 customerName 或 contactName -->
                    <template v-if="scope.row.customerName || scope.row.contactName">
                      <router-link :to="`/email/customer/detail/${scope.row.customerId}?type=1`">
                        <OverflowTooltip
                            :content="scope.row.contactEmail ? scope.row.contactEmail : `${scope.row.customerName} (${scope.row.companyEmail})`"
                            :max-width="180"
                            :show-after="1200"
                        >
                          <span class="tooltip-content-wrap">{{ scope.row.customerName }}</span>
                        </OverflowTooltip>
                      </router-link>
                    </template>

                    <!-- 没有 customerName，判断收件人数量 -->
                    <template v-else>
                      <template v-if="scope.row.mailRecipientList?.length > 1">
                        <OverflowTooltip
                            :content="scope.row.mailRecipientList.join(', ')"
                            :max-width="180"
                            :show-after="1200"
                        >
                          <span class="tooltip-content-wrap">
                            {{ `${scope.row.mailRecipientList[0]} ...` }}
                          </span>
                        </OverflowTooltip>
                      </template>
                      <template v-else>
                        <OverflowTooltip
                            :content="scope.row.customerName || scope.row.mailRecipientList?.[0]"
                            :max-width="180"
                            :show-after="1200"
                        >
                          <span class="tooltip-content-wrap">
                            {{ scope.row.customerName || scope.row.mailRecipientList?.[0] }}
                          </span>
                        </OverflowTooltip>
                      </template>
                    </template>
                  </template>
                </el-table-column>
                <el-table-column prop="subject" :label="$t('common.subject')">
                  <template #default="scope">
                    <div
                        class="subject-cell"
                        style="display: flex; align-items: center; position: relative;"
                    >
                      <!-- 紧急图标 -->
                      <!--                      <img-->
                      <!--                          v-if="scope.row.urgent === 1"-->
                      <!--                          src="../../assets/svg/warning.svg"-->
                      <!--                          class="urgent-icon"-->
                      <!--                      />-->

                      <!-- 内容部分，是否溢出决定是否显示 tooltip -->
                      <OverflowTooltip
                          :content="scope.row.subject"
                          :show-after="1200"
                      >
                        <a
                            @click.stop="handleViewDetail(scope.row)"
                            class="subject-text"
                        >
                          <span v-html="highlightKeyword(scope.row.subject, searchCount)"></span>
                        </a>
                      </OverflowTooltip>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="createTime" :label="$t('common.date')" class-name="sort_ps"
                                 sortable="custom" width="160"/>
                <el-table-column prop="userName" :label="$t('common.staff')" width="160">
                  <template #default="scope">
                    <OverflowTooltip
                        v-if="scope.row.userName"
                        :content="scope.row.userName"
                        :show-after="1200"
                    >
                      <span class="tooltip-content-wrap">{{ scope.row.userName }}</span>
                    </OverflowTooltip>
                  </template>
                </el-table-column>
                <el-table-column fixed="right" :label="$t('common.cz')" :width="lang!=='zh-CN'?150:120">
                  <template #default="scope">
                    <template v-if="isAdmin||isSuperAdmin">
                      <el-button link type="primary" size="small"
                                 @click="() => handleSingle(scope.row, 1)"
                      >{{ $t('common.pass') }}
                      </el-button
                      >
                      <el-button link type="danger" size="small"
                                 @click="() => handleSingle(scope.row, 2)">
                        {{ $t('common.reject') }}
                      </el-button>
                    </template>
                    <template v-else>
                      <el-button link type="info" size="small">-</el-button>
                      <el-button link type="info" size="small">-</el-button>
                    </template>
                  </template>
                </el-table-column>
                <template #empty>
                  <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
                </template>
              </ElTable>
            </div>
            <div title="移动到边界进行位置调整" class="mover">
              <div class="mail_info" ref="moveTarget">
                <div class="up_row move"></div>
                <div style="width: 100%;height: 26px;display: flex">
                  <div class="from over_text">
                    {{ $t('common.email.from') }}：{{ currentMail.mailBody?.from }}
                  </div>
                  <div class="to over_text" ref="toRef">
                    <el-popover
                        v-if="formatText(currentMail.mailRecipientVOList, 'to')"
                        :visible="visibleTo"
                        width="500"
                        :content="formatText(currentMail.mailRecipientVOList, 'to')"
                        :effect="'dark'"
                        popper-class="visible"
                    >
                      <template #reference>
                    <span @mouseenter="showPopover(formatText(currentMail.mailRecipientVOList, 'to'),'to')"
                          @mouseleave="delayedHidePopover('to')">{{
                        $t('common.email.to')
                      }}：{{ formatText(currentMail.mailRecipientVOList, 'to') }}</span>
                      </template>
                      <div @mouseenter="keepPopoverVisible('to')" @mouseleave="hidePopover('to')">
                        {{ formatText(currentMail.mailRecipientVOList, 'to') }}
                      </div>
                    </el-popover>
                    <template v-else>
                      {{ $t('common.email.to') }}：{{ formatText(currentMail.mailRecipientVOList, 'to') }}
                    </template>
                  </div>
                  <div class="cc over_text">
                    <el-popover
                        v-if="formatText(currentMail.mailRecipientVOList, 'cc')"
                        :visible="visibleCC"
                        width="500"
                        :content="formatText(currentMail.mailRecipientVOList, 'cc')"
                        :effect="'dark'"
                        popper-class="visible"
                    >
                      <template #reference>
                <span
                    @mouseenter="showPopover(formatText(currentMail.mailRecipientVOList, 'cc'),'cc')"
                    @mouseleave="delayedHidePopover('cc')"
                >
                {{ $t('common.cc') }}：{{ formatText(currentMail.mailRecipientVOList, 'cc') }}
                </span>
                      </template>
                      <div @mouseenter="keepPopoverVisible('cc')" @mouseleave="hidePopover('cc')">
                        {{ formatText(currentMail.mailRecipientVOList, 'cc') }}
                      </div>
                    </el-popover>
                    <template v-else>
                      {{ $t('common.cc') }}：{{ formatText(currentMail.mailRecipientVOList, 'cc') }}
                    </template>
                  </div>
                </div>
                <div class="down_row move"></div>
              </div>
            </div>
            <div class="downBox" :style="{height:`calc(100% - ${fileInboxTop + 10}px)`}">
              <!--右下div内容-->
              <!--              <iframe ref="pageframe" id="pageframe"-->
              <!--                      :srcdoc="iframeContent"-->
              <!--                      frameborder="0"-->
              <!--                      :style="{width: '100%',height: '100%'}"-->
              <!--                      :class="detailLoading?'scroll':'scroll loaded'"-->
              <!--              >-->
              <!--                <p>Your browser does not support preview features, please download Google browser or other modern-->
              <!--                  browsers.</p>-->
              <!--              </iframe>-->
              <div v-loading="detailLoading" style="width: 100%;height: 100%">
                <iframe ref="pageframe" id="pageframe" :srcdoc="iframeContent"
                        frameborder="0"
                        :style="{width: '100%',height: '100%'}"
                        :class="detailLoading?'scroll':'scroll loaded'"
                >
                  <p>Your browser does not support preview features, please download Google browser or other modern
                    browsers.</p>
                </iframe>
                <div v-if="isDragging" id="mask"
                     :style="{width: '100%',height:`calc(100% - ${fileInboxTop + 10}px)`,background:'rgba(0,0,0,0)',position:'absolute',zIndex:999,top:fileInboxTop+'px'}">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {onMounted, ref, computed, watch, onBeforeUnmount, nextTick} from 'vue';
import {useStore} from 'vuex';
import {ElMessage} from 'element-plus';
import {requestAuditMailList, requestBatchAuditEmail, requestMailAccessory} from '@/api/mail';
import {getMailByUserId, getMailDetails, tagMail} from '../../api/index';
import {emptyUrl, TIME_OUT} from "@/utils/statusParams";
import {useRoute, useRouter} from "vue-router";
import {debouncePlus, throttle} from "@/utils/mylodash"
import {addImgOnErrorAttribute, containsHtmlTags, convertLinksToHTML, convertToHTML} from "@/utils/iframe";
import {getScaleValue} from "@/utils/view";
import {getTeamUserListAll} from "@/api/groups";
import {i18n} from "@/lang";
import {AlarmClock} from "@element-plus/icons-vue";
import {highlightKeyword} from "@/utils/util";
import OverflowTooltip from "@/components/OverflowTooltip/index.vue";
import sessionStore from "@/utils/sessionStore";
import {Storage} from "@/utils/storage";

export default {
  methods: {highlightKeyword},
  components: {OverflowTooltip, AlarmClock},
  setup() {
    const isShiftPressed = ref(false); // 标记 Shift 键是否被按下
    const store = useStore();
    const teamId = computed(() => store.state.email.teamID);
    const route = useRoute()
    const current = ref(1);
    const size = ref(10);
    const total = ref(0);
    const list = ref([]);
    const loading = ref(false);
    const currentMail = ref({});
    const multipleSelection = ref([]);
    const iframeContent = ref('');
    const tableHeight = ref(200);
    const inboxRef = ref(null);
    const router = useRouter()
    const dragBoxHeight = ref(0)
    const DragBox = ref(null)
    const configId = ref('all');
    const selectedTeamId = ref('');
    const selectedFolder = ref("");
    const tableDataSelect = ref([]);
    const emailList = ref([]);
    const selectedUserIdMap = ref({});

    // 权限控制
    const isSuperAdmin = computed(() => store.getters["user/isSuperAdmin"])
    const isAdmin = computed(() => store.getters["user/isAdmin"])

    const targetFileList = computed(() => route.path !== '/email/inbox' && route.path !== '/email/has_send' && route.path !== '/email/draft' && route.path !== '/email/waste' && route.path !== '/email/foldergroup' ? [{
      "id": "99999",
      "fileName": i18n.global.t('common.emailbox.receive'),
    }, {
      "id": "99999",
      "fileName": i18n.global.t('common.has.sent'),
    }, ...store.state.sidebar.targetFileList.filter(item => item.id !== selectedFolder.value)] : store.state.sidebar.targetFileList.filter(item => item.id !== selectedFolder.value))

    const teamList = computed(() => store.state.email.teamList)
    const handleSelectUser = async (val) => {
      console.log(val, 'user')
      // if (route.path === '/email/foldergroup') {
      console.log(val, 'val', selectedTeamId.value);
      await store.commit("sidebar/setTargetFileList", [])
      await store.dispatch("sidebar/getEmailGroupFileListApis", {teamId: teamId.value, userId: selectedTeamId.value})
      selectedFolder.value = targetFileList.value.filter(item => item.id !== "99999").length >= 1 ? targetFileList.value[1].id : "";
      await getList()
      // }
    }
    const handleSelectFolder = async (val) => {
      console.log(val, 'val')
      selectedFolder.value = val;
      await getList()
    }

    async function getAllUserList() {
      const result = await getTeamUserListAll({teamId: teamId.value});
      if (result.code !== 200) {
        ElMessage.error(result.message)
        return
      }
      console.log(result.result, 'result.result')

      // 如果没有查到相关的id那么就需要跳转到默认 选中项
      // await store.dispatch('email/getTeamList');
      if (result.result && result.result.length === 0) {
        if (teamList.value.length >= 1) {
          const nextTeamId = String(teamList.value[0].id)
          store.commit('email/setCurTeamID', nextTeamId)
        } else {
          store.commit('email/setCurTeamID', '')
          //   如果查询到没有团队的详情的话那么就跳转到首页
          router.push("/dashboard")
        }
      }
      console.log(result.result, 'result.result')
      if (!route.params.folderId) {
        tableDataSelect.value = result.result || [];
      } else {
        tableDataSelect.value = result.result.filter(item => String(item.userId) === activeUserId.value)
      }
      if (isAdmin.value || isSuperAdmin.value) {
        selectedTeamId.value = i18n.global.t('common.all')
      } else {
        if (tableDataSelect.value.length) {
          console.log(tableDataSelect.value, tableDataSelect.value.find(_ => String(_.userId) === activeUserId.value), 'tableDataSelect.value')
          selectedTeamId.value = tableDataSelect.value.find(_ => String(_.userId) === activeUserId.value)?.userId;
          selectedUserIdMap.value = tableDataSelect.value.reduce((prev, item) => {
            prev[item.id] = item.userId;
            return prev;
          }, {});
        }
      }
    }

    function getMailListConf() {
      getMailByUserId({teamId: teamId.value, userId: selectedTeamId.value || ''})
          .then((res) => {
            // // console.log(res.result, '邮箱配置列表');
            const list = res.result || [];
            emailList.value = list.map(item => ({label: item.username, value: item.id}));
          });
    }

    function handleSizeChange() {
    }

    function handleCurrentChange(val) {
      current.value = val
      getList()
    }

    const detailLoading = ref(false)

    async function handleCurrentRowChange(current) {
      console.log(current, 'ff');
      if (current) {
        detailLoading.value = true
        try {
          const result = await getMailDetails({id: current.id});
          let content = result.result?.mailBody?.content;
          console.log(content, 'iframeContent')
          detailLoading.value = false
          const insertionContent = `<script>
            function errorImage(img) {
                console.log(img,'img')
                img.onerror = null;
                img.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAADElEQVR42mP4//8/AAX+Av4zEpUUAAAAAElFTkSuQmCC"
            }
        <\/script>`;
          if (!content) {
            iframeContent.value = ''
          } else {
            if (containsHtmlTags(content)) {
              const replacedHtmlString = addImgOnErrorAttribute(content)
              console.log('content', replacedHtmlString);
              const res = replacedHtmlString.replace(/(<html[^>]*>)/, '$1' + insertionContent);
              iframeContent.value = res;
            } else {
              // 纯图片需要直接展示
              if (content.indexOf('https://s3gw.cmbimg.com') !== -1) {
                iframeContent.value = content;
              } else {
                iframeContent.value = convertLinksToHTML(convertToHTML(content))
              }
            }
          }

          console.log(iframeContent.value, 'iframeContent')
          currentMail.value = result.result;
          detailLoading.value = false
        } catch (e) {
          detailLoading.value = false
        }
      }
    }

    const tableRef = ref(null)

    function handleSelectionChange(val) {
      // console.log("val-----------------------", val)
      //判断是否按住shirt键盘
      console.log(isShiftPressed.value);
      endIndex = val.length > 1 ? list.value.findIndex(item => item.id === val[val.length - 1].id) : -1;
      const startIndex = val.length > 1 ? list.value.findIndex(item => item.id === val[val.length - 2].id) : -1;
      console.log(endIndex, startIndex);
      if (isShiftPressed.value && val.length > 1 && endIndex !== startIndex) {
        const start = startIndex < endIndex ? startIndex : endIndex;
        const end = endIndex < startIndex ? startIndex : endIndex;
        // console.log(start, end, '===============');
        for (let i = start; i <= end; i++) {
          const row = list.value[i];
          if (start === i || i === end) {
            continue;
          }
          console.log(row, '更新');
          if (row) {
            tableRef.value.toggleRowSelection(row, true); // 调用表格组件的方法来更新选中状态
          }
        }
        nextTick(() => {
          multipleSelection.value = tableRef.value.getSelectionRows();
          console.log(tableRef.value.getSelectionRows(), '当前选中行');
        });
      } else {
        //走正常逻辑
        multipleSelection.value = val;
      }
    }

    async function getList(sort) {
      loading.value = true;
      let payload = {
        pageNo: current.value,
        pageSize: size.value,
        teamId: teamId.value,
        mailConfigId: configId.value === 'all' ? null : configId.value,
        userId: selectedTeamId.value === i18n.global.t('common.all') ? '' : selectedTeamId.value,
        // orderTime: 2,
      }
      if (sort) {
        payload = {...payload, ...sort}
      }
      const res = await requestAuditMailList(payload);
      loading.value = false;
      if (res.code !== 200) {
        ElMessage.error(res.message);
        return;
      }
      list.value = res.result?.records || [];
      total.value = res.result?.total;
    }

    async function batchAuditEmail(type) {
      console.log(multipleSelection.value[0].id, 'multipleSelection.value')
      if (type === 1) {
        btnIsLoadingResolve.value = true
      } else {
        btnIsLoadingReject.value = true
      }
      const result = await requestBatchAuditEmail({
        auditStatus: type,
        idList: multipleSelection.value.map(item => item.id)
      });
      if (type === 1) {
        btnIsLoadingResolve.value = false
      } else {
        btnIsLoadingReject.value = false
      }
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      ElMessage.success(result.message)
      getList();
      // 更新标志
      await store.dispatch('countshow/getTeamAllDataApis')
      console.log('审核邮件', result);
    }

    function handlePass(type) {
      if (!multipleSelection.value.length) {
        ElMessage.error(i18n.global.t('sys.tip.unselect.email'));
        return;
      }
      batchAuditEmail(type);
    }

    const btnIsLoadingResolve = ref(false)
    const btnIsLoadingReject = ref(false)
    const handleSingle = throttle((row, type) => {
      multipleSelection.value = [row];
      console.log(multipleSelection.value, '000000')
      batchAuditEmail(type);
    }, TIME_OUT)

    function formatText(list, type) {
      console.log(list, type);
      if (!list || !list.length) {
        return '';
      }
      const infoMap = list.reduce((prev, item) => {
        if (!prev[item.mailType]) {
          prev[item.mailType] = [];
        }
        prev[item.mailType].push(item.mail);
        return prev;
      }, {});
      return infoMap[type] ? infoMap[type].join(',') : '';
    }

    watch(() => teamId.value, async () => {
      console.log('组件团队ID 监听', teamId.value);
      await getList();
      if (teamId.value) {
        configId.value = 'all';
        await getMailListConf();
        await getAllUserList();
      }
    })
    watch(() => selectedTeamId.value, (value, item) => {
      console.log('组件团队ID 监听', teamId.value);
      if (selectedTeamId.value !== item) {
        // getList();
        getMailListConf();
        // store.dispatch("user/checkUserInfoIsAdmin", {teamId: teamId.value})
      }
    });
    // 页面进行缩放
    const adjustContentPosition = debouncePlus(() => {
      console.log('resize')
      localStorage.setItem("resize", true)
      router.go(0)
    }, 200)

    onMounted(async () => {
      loading.value = true;
      document.addEventListener('keydown', handleKeyDown);
      document.addEventListener('keyup', handleKeyUp);
      await nextTick()
      if (DragBox.value) {
        dragBoxHeight.value = DragBox.value.offsetHeight - 30;
      }
      store.commit("sidebar/setTargetFileList", [])
      store.commit("sidebar/setPageSetting", {type: 'pageNo', value: 1})
      store.dispatch("sidebar/getEmailGroupFileListApis", {teamId: teamId.value, userId: activeUserId.value})
      // elementTop.value = tableHeight.value
      store.dispatch('customer/getAreaNames')
      store.dispatch("cusList/getMailCustomerLevel", {teamId: teamId.value});
      await store.dispatch("system/getTargetHeight", {userId: activeUserId.value})
      dragControllerUD();
      await getAllUserList();
      if (teamId.value) {
        getList();
      }
      window.addEventListener('resize', adjustContentPosition);
    })


    onBeforeUnmount(() => {
      window.removeEventListener('resize', adjustContentPosition);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
    });

    let endIndex = -1;
    //按住shirt键
    const handleKeyDown = (event) => {
      console.log(event.key, 'event.key')
      if (event.key === 'Shift' && event.keyCode === 16) {
        // console.log("进来了-----------------", event.key, event.keyCode);
        isShiftPressed.value = true;
      }
    };

    const handleKeyUp = (event) => {
      if (event.key === 'Shift' && event.keyCode === 16) {
        isShiftPressed.value = false;
      }
    };


    const userInfo = computed(() => store.state.user.userInfo)

    const ACCOUNTS_STORAGE_KEY = 'accounts'
    const activeUserId = computed(() => {
      const fromUserInfo = userInfo.value?.id ?? userInfo.value?.userID ?? userInfo.value?.guid ?? userInfo.value?.account
      const fromAccounts = Storage.get(ACCOUNTS_STORAGE_KEY)?.currentId
      const id = fromUserInfo ?? fromAccounts
      return id === undefined || id === null ? '' : String(id)
    })
    // 上下拖动事件
    const topBoxValue = ref(0);
    const downBoxValue = ref(0);
    // 移动
    const moveTarget = ref(null);
    const scrollBox = ref(null);
    const isDragging = ref(false);
    const initialMouseY = ref(0);
    const elementLeft = ref(0);
    const draggableHeight = ref(30);
    const fileInboxHeight = computed(() => store.state.system.fileInboxHeight)
    const fileInboxTop = computed(() => {
      return topBoxValue.value !== 0 ? topBoxValue.value : store.state.system.fileInboxTop > dragBoxHeight.value ? dragBoxHeight.value : store.state.system.fileInboxTop
    });
    const elementTopRaw = ref(fileInboxTop.value);
    const elementTop = computed({
      get() {
        return elementTopRaw.value;
      },
      set(newValue) {
        elementTopRaw.value = newValue;
      },
    });

    const pageframeHeightRaw = ref(fileInboxHeight.value);
    const pageframeHeight = computed({
      get() {
        return pageframeHeightRaw.value;
      },
      set(newValue) {
        pageframeHeightRaw.value = newValue;
      },
    });

    function startDrag(e) {
      e = e || window.event;
      isDragging.value = true;
      initialMouseY.value = e.clientY;
    }

    const saveTargetHeight = debouncePlus((userId, pageframeHeight, elementTop) => {
      store.dispatch("system/settingTargetHeight", {
        userId,
        fileInboxHeight: pageframeHeight,
        fileInboxTop: elementTop
      });
    }, 200); // 300ms 防抖延迟

    function stopDragEx() {
      // 结束拖拽
      isDragging.value = false;
    }

    const rowClassName = ({row, column, rowIndex, columnIndex}) => {
      console.log(row, columnIndex, '333')
      if (columnIndex === 2) {
        return {'text-align': 'center'}
      } else {
        return {'text-align': 'left'}
      }
    }

    const headerClassName = ({row, column, rowIndex, columnIndex}) => {
      if (columnIndex === 2) {
        return {'text-align': 'center'}
      } else {
        return {'text-align': 'left'}
      }
    }


    const sidebarTargetNumber = computed(() => store.state.countshow.sidebarTargetNumber)
    watch(() => sidebarTargetNumber.value, async () => {
      await getList();
    })
    watch(() => configId.value, async () => {
      await getList();
    });
    const visibleTo = ref(false)
    const visibleCC = ref(false)
    const hidePopoverTimeout = ref(false)

    function showPopover(string = '', flag) {
      if (moveTarget.value) {
        const itemWidth = Math.round((moveTarget.value.clientWidth - 40) * (1 / 3))
        const stringWidth = string.pxWidth('normal 12px PingFangSC, PingFang SC')
        console.log(itemWidth, stringWidth)
        if (stringWidth + 20 > itemWidth) {
          if (flag === "to") {
            visibleCC.value = false;
            visibleTo.value = true;
          } else if (flag === "cc") {
            visibleTo.value = false;
            visibleCC.value = true;
          }
          if (hidePopoverTimeout.value) {
            clearTimeout(hidePopoverTimeout.value);
            hidePopoverTimeout.value = null;
          }
        }
      }
    }

    function delayedHidePopover(flag) {
      hidePopoverTimeout.value = setTimeout(() => {
        flag === "to" ? visibleTo.value = false : visibleCC.value = false;
      }, 200); // Adjust delay as necessary
    }

    function keepPopoverVisible(flag) {
      if (hidePopoverTimeout.value) {
        clearTimeout(hidePopoverTimeout.value);
        hidePopoverTimeout.value = null;
      }
      flag === "to" ? visibleTo.value = true : visibleCC.value = true;
    }

    function hidePopover(flag) {
      flag === "to" ? visibleTo.value = false : visibleCC.value = false;
    }

    function dragControllerUD() {
      var resize = document.getElementsByClassName("move");
      var topBox = document.getElementsByClassName("topBox");
      var downBox = document.getElementsByClassName("downBox");
      var box = document.getElementsByClassName("mid");
      console.log(document.getElementsByClassName("move"), resize.length, 'resize.length');
      for (let i = 0; i < resize.length; i++) {
        // 鼠标按下事件
        resize[i].onmousedown = function (e) {
          console.log(resize[i].top);
          //颜色改变提醒
          resize[i].style.background = "#818181";
          // 100 这里是 有上面的 操作栏的高度
          var startY = e.clientY + 120;
          resize[i].top = resize[i].offsetTop;
          // 鼠标拖动事件
          document.onmousemove = function (e) {
            isDragging.value = true
            var endY = e.clientY;
            var moveLen = resize[i].top + (endY - startY); // （endY - startY）=移动的距离。resize[i].top+移动的距离=上边区域最后的高度
            var maxT = box[0].clientHeight - resize[i].offsetHeight; // 容器高度 - 上边区域的高度 = 下边区域的高度

            if (moveLen < 30) moveLen = 30; // 上边区域的最小高度为50px
            if (moveLen > maxT - 30) moveLen = maxT - 30; //下边区域最小高度为150px

            resize[i].style.top = moveLen; // 设置上边区域的高度

            for (let j = 0; j < topBox.length; j++) {
              topBox[j].style.height = moveLen + "px";
              topBoxValue.value = moveLen
              downBox[j].style.height = box[0].clientHeight - moveLen - 10 + "px";
              downBoxValue.value = box[0].clientHeight - moveLen - 10
              saveTargetHeight(activeUserId.value, box[0].clientHeight - moveLen - 10, moveLen);
            }
          };
          // 鼠标松开事件
          document.onmouseup = function () {
            //颜色恢复
            isDragging.value = false
            resize[i].style.background = "#d6d6d6";
            document.onmousemove = null;
            document.onmouseup = null;
            resize[i].releaseCapture && resize[i].releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
          };
          resize[i].setCapture && resize[i].setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获
          return false;
        };
      }
    }

    function tableRowClassName({row, rowIndex}) {
      return `read_${row.isRead}`;
    }


    const commandList = [1, 0, 1, 0];

    async function handleSettingStress(scope, type) {
      // // console.log(scope.row, type);
      multipleSelection.value = [scope.row];
      handleCommand(type);
      // 更新标志
      // await store.dispatch('countshow/getTeamAllDataApis')
    }

    async function handleCommand(val) {
      // // console.log(val, multipleSelection.value);
      if (!multipleSelection.value.length) {
        ElMessage.error(i18n.global.t('sys.tip.unselect.email'));
        return;
      }
      const type = val === 0 || val === 1 ? 'isRead' : 'isStress';
      requestTagMail(commandList[val], type);
    }

    async function requestTagMail(tag, type) {
      const result = await tagMail({
        [type]: tag,
        mailIdList: multipleSelection.value.map(item => item.id),
      });
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      // 更新标志
      await store.dispatch('countshow/getTeamAllDataApis')

      if (multipleSelection.value.length === 1) {
        let isStress = multipleSelection.value[0][type]
        console.log(isStress, 'isStress')
        //   软删除
        list.value = list.value.map(item => {
          if (item.id === multipleSelection.value[0].id) {
            return {...item, [type]: isStress === 1 ? 0 : 1}
          } else {
            return item
          }
        })
      } else {
        // 删除刷新
        await getList()
      }
    }


    const handleSetRead = async (scope) => {
      const isRead = scope.row.isRead;
      const result = await tagMail({
        isRead: isRead === 1 ? 0 : 1,
        mailIdList: [scope.row.id],
      });
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      list.value = list.value.map(item => {
        if (item.id === scope.row.id) {
          return {...item, isRead: isRead === 1 ? 0 : 1}
        } else {
          return item
        }
      })
    }


    async function handleDownload(scope) {
      const result = await requestMailAccessory({id: scope.row.id});
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      console.log(result, 'result')
      window.open(`${location.origin}/email/detail/${scope.row.id}/${JSON.stringify({
        flag: scope.row.flag ? scope.row.flag : 0,
        isExtend: scope.row.isExtend ? scope.row.isExtend : 0,
        from: scope.row.from
      })}/${props.type}`);
    }

    const sortObj = ref({})

    function sort_change({column, prop, order}) {
      console.log('ffff', column, prop, order)
      if (order != null) {
        const flag = order === 'descending' ? 2 : 1;
        // 映射排序字段到相应的请求参数
        const sortMapping = {
          isStress: 'orderStress',
          isRead: 'orderRead',
          fj: 'orderExtend',
          createTime: 'orderTime',
          contentSize: 'orderSize'
        };

        // 获取相应的请求参数
        const requestParam = sortMapping[prop];
        sortObj.value = {[requestParam]: flag};
        console.log(sortObj.value, 'sortObj')
        if (requestParam) {
          getList({[requestParam]: flag});
        }
      } else {
        getList()
      }
    }

    const getTargetMailId = ref(null)

    async function handleViewDetail(row) {
      console.log('双击', row);
      // if (props.type === 3) {
      //   const query = {id: row.id, flag: row.flag, type: "resend"};
      //   if (row.flag === 0 && row.customerId) {
      //     query.customerId = row.customerId;
      //   }
      //   router.push({
      //     path: '/email/write_mail',
      //     query,
      //   });
      // } else if (props.type === 2) {
      //   const query = {id: row.id, flag: row.flag, type: "editMail", fromType: props.type};
      //   if (row.flag === 0 && row.customerId) {
      //     query.customerId = row.customerId;
      //   }
      //   router.push({
      //     path: '/email/write_mail',
      //     query,
      //   });
      // } else {
      getTargetMailId.value = row.id
      //邮件已读
      multipleSelection.value = [row]
      // 已读的邮件 避免被重复赋值
      if (row?.isRead !== 1) {
        await requestTagMail(commandList[0], 'isRead');
      }
      window.open(`${location.origin}/email/detail/${row.id}/${JSON.stringify({
        flag: row.flag ? row.flag : 0,
        isExtend: row.isExtend ? row.isExtend : 0,
        from: row.from,
        customerId: row.customerId,
      })}/${5}`);

      // window.location.href = `${location.origin}/email/detail/${row.id}/${JSON.stringify({
      //     flag: row.flag ? row.flag : 0,
      //     isExtend: row.isExtend ? row.isExtend : 0,
      //     from: row.from,
      //   })}/${props.type}`;
      await getList();
      // }
    }


    return {
      getTargetMailId,
      handleViewDetail,
      isSuperAdmin,
      isAdmin,
      tableRef,
      sort_change,
      handleDownload,
      handleSetRead,
      handleCommand,
      handleSettingStress,
      tableRowClassName,
      targetFileList,
      emailList,
      configId,
      handleSelectFolder,
      tableDataSelect,
      selectedFolder,
      getAllUserList,
      handleSelectUser,
      selectedTeamId,
      DragBox,
      fileInboxTop,
      dragControllerUD,
      showPopover,
      delayedHidePopover, keepPopoverVisible, hidePopover,
      detailLoading,
      visibleTo,
      visibleCC,
      rowClassName,
      headerClassName,
      scrollBox,
      initialMouseY,
      draggableHeight,
      moveTarget,
      pageframeHeight,
      elementLeft,
      elementTop,
      startDrag,
      current,
      size,
      total,
      list,
      loading,
      currentMail,
      iframeContent,
      tableHeight,
      inboxRef,
      formatText,
      handlePass,
      handleSingle,
      handleCurrentChange,
      handleSizeChange,
      handleSelectionChange,
      handleCurrentRowChange,
      emptyUrl,
      btnIsLoadingResolve,
      btnIsLoadingReject,
      isDragging
    }
  }
}
</script>

<style lang="less" scoped>
.wrap {
  background-color: rgb(245, 245, 245);
  padding: 8px 0px 8px 8px !important;
  height: -webkit-fill-available !important;
  //overflow: hidden;

  :deep(.el-form-item) {
    margin: 20px 0 0;
  }

  .exam {
    background-color: #fff;
    height: 100%;

    .screen {
      display: flex;
      justify-content: space-between;
      padding: 6px 0;
      background-color: #f5f5f5;
    }

    .current_mail {

      //padding: 0px 20px;

      .mail_info {
        display: flex;
        flex-direction: column;
        height: 30px;
        align-items: center;
        background: rgb(229, 229, 229);
        //user-select: text;
        cursor: n-resize;
        transform: translateZ(0);
        will-change: transform;
        font-family: "PingFangSC, PingFang SC";

        & > div:nth-of-type(2) {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          padding: 0px 20px;
          height: 26px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 12px;
          cursor: text !important;

          & > div {
            width: 33.33%;
            min-width: 33.33% !important;
            max-width: 33.33% !important;
          }
        }
      }
    }

    & > .bg_w {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 10px;

      .span {
        font-size: 14px;
        color: rgba(0, 0, 0, .65);
      }
    }
  }

  :deep(.el-empty__image img) {
    width: 54% !important;
  }

  :deep(.el-empty__description) {
    margin-top: -20px;
  }

  .scroll_out_box {
    position: relative;
  }

  .mail_info {
    width: 100%;
    height: 26px;
  }

  #pageframe {
    background: white;
  }
}

.up_row, .down_row {
  width: 100%;
  height: 2px !important;
  cursor: row-resize !important;
}

.over_text {
  color: black !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 26px;
  width: 33.33%;
  text-align: left;
}

iframe {
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

iframe.loaded {
  opacity: 1;
}

:deep(.el-popper) {
  max-width: 45% !important;
}

.visible {
  padding: 0px !important;

  & > div {
    margin: -12px !important;
    padding: 8px !important;
  }
}

.Drag2 {
  height: calc(100vh - 146px);
}

/*包围div样式*/
.box {
  width: 100%;
  height: 100%;
  margin: 0px 0px;
  overflow: hidden;
  box-shadow: -1px 9px 10px 3px rgba(0, 0, 0, 0.11);
}

/*左侧div样式*/
.left {
  width: calc(32% - 10px); /*左侧初始化宽度*/
  height: 100%;
  background: #71ad88;
  float: left;
}

/* 拖拽区div样式 */
.resize {
  cursor: w-resize;
  float: left;
  position: relative;
  top: 45%;
  background-color: #d6d6d6;
  border-radius: 5px;
  margin-top: -10px;
  width: 10px;
  height: 50px;
  background-size: cover;
  background-position: center;
  /*z-index: 99999;*/
  font-size: 32px;
  color: white;
}

/*拖拽区鼠标悬停样式*/
//.movers:hover {
//  color: #444444;
//}

/*右侧div'样式*/
.mid {
  float: left;
  width: 100%; /*右侧初始化宽度*/
  height: 100%;
  background: #f3f3f3;
  box-shadow: -1px 4px 5px 3px rgba(0, 0, 0, 0.11);
  /*上方div'样式*/

  .topBox {
    height: 60%;
    background-color: #3ff53f;
    display: flex;
  }

  /*下方div'样式*/

  .downBox {
    //height: calc(40% - 32px);
    //background-color: #f0fd35;
    background: white;
    display: flex;
  }

  /* 拖拽区div样式 */

  .mover {
    padding: 0px 20px;
    //cursor: s-resize;
    cursor: text;
    width: 100%;
    height: 30px;
    background-color: #d6d6d6;
    border-radius: 5px;
    text-align: center;
    line-height: 3px;
    font-size: 12px;
    user-select: text; /* 启用文本选择 */
  }

  /*拖拽区鼠标悬停样式*/

  .mover:hover {
    color: #444444;
  }
}

#pageframe {
  padding-bottom: 30px;
}

:deep(.el-table .sort_ps .caret-wrapper) {
  display: none !important; /* 应用样式，覆盖默认样式 */
}

:deep(.el-table .sort_ps .cell) {
  text-overflow: unset !important;
}


:deep(.el-tabs__item:focus.is-active.is-focus:not(:active)) {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.pointer {
  cursor: pointer !important;
}

:deep(.el-select--small .el-select__wrapper) {
  font-size: 13px !important;
}

:deep(.el-input__inner) {
  font-size: 13px !important;
}

.tooltip-content-wrap {
  max-width: 300px;
  max-height: 200px;
  overflow-y: auto;
  white-space: normal;
  word-break: break-word;
  padding: 4px;
}

.urgent-icon {
  width: 15px;
  height: 15px;
  position: relative;
  top: 3px;
}

:deep(.el-button+.el-button) {
  margin-left: 2px !important;
}
</style>